<template>
  <v-container id="regular-tables-view" fluid tag="section">
    <material-card icon="mdi-format-list-numbered-rtl" icon-small :title="'گزارش صورتحساب های الکترونیکی نمایندگان'" color="accent">
      <v-tabs v-model="activeTab" background-color="whitesmoke" centered color="secondary" slider-color="secondary">
        <v-tab :key="0">صورتحساب ها</v-tab>
        <v-tab :key="1">تسویه حساب ها</v-tab>

        <v-tabs-items v-model="activeTab" touchless class="mt-3">
          <v-tab-item :key="0">
            <AgentFactors ref="agentFactor" @add="add" @edit="edit" @remove="remove" userType="admin" :autoSubmit="autoSubmit" :hideDateRange="hideDateRange" :member="member" :agent="agent" />
          </v-tab-item>
          <v-tab-item :key="1">
            <AgentFactorCheckoutTransactions area="admin" :showDateFilter="true" @showFactor="showAgentFactor"/>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>

      <v-dialog v-model="dialogModify" scrollable max-width="650px">
        <AgentFactorModify v-if="dialogModify" @close="dialogModify = false" @print="print" :data="selectedItem" userType="admin" />
      </v-dialog>
    </material-card>
  </v-container>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'
import AgentFactors from '@/components/forms/AgentFactors.vue'

export default {
  name: 'AgentFactorsView',
  props: {
    autoSubmit: { type: Boolean, default: false },
    hideDateRange: { type: Boolean, default: false },
    member: { type: Object },
    agent: { type: Object },
  },
  components: {
    ConfirmDlg: () => import('@/components/Confirm'),
    AgentFactors: AgentFactors,
    AgentFactorModify: () => import('@/components/forms/AgentFactorModify'),
    AgentFactorCheckoutTransactions: () => import('@/components/forms/AgentFactorCheckoutTransactions'),
  },
  data() {
    return {
      activeTab: 0,
      selectedItem: null,
      errorMessages: '',
      dialogModify: false,
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    add(item) {
      this.selectedItem = item
      this.dialogModify = true
    },
    edit(item) {
      api.get(`admin/AgentFactor/Get/${item.id}`, null)
        .then((response) => {
          this.selectedItem = response
          this.dialogModify = true
        })
        .catch((err) => {
          toast.error(err.message)
        })
        .finally(() => {})
    },
    remove(item) {},
    print(item) {
      this.$refs.agentFactor.print(item)
    },
    showAgentFactor(id) {
      api.get(`admin/AgentFactor/Get/${id}`, null)
        .then((response) => {
          this.edit(response)
        })
        .catch((err) => {
          toast.error(err.message)
        })
        .finally(() => {})
    },
  },
}
</script>
<style></style>
